import styled, { css } from 'styled-components';

export const WrapperInputSearch = styled.div<{ isTextFieldFocus: boolean }>`
  ${({ theme, isTextFieldFocus }) => css`
    width: 100%;
    @media screen and (min-width: ${theme.breakpoint.lg.minWidth}) {
      visibility: ${isTextFieldFocus ? 'visible' : 'hidden'};
      position: absolute;
      top: 0;
    }

    fuel-text-field::part(input) {
      padding: 0 40px 0 113px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    fuel-text-field {
      min-width: 312px;
      z-index: ${isTextFieldFocus ? theme.zIndex.modal : theme.zIndex.absolute};

      :focus::before {
        background-color: ${theme.color.background.neutral.strong};
        color: ${theme.color.text.neutral.default};
      }

      ::before {
        content: 'Pré-consulta';
        position: absolute;
        z-index: ${isTextFieldFocus ? theme.zIndex.modal : theme.zIndex.absolute};
        text-align: center;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        height: 46px;
        margin-top: 1px;
        padding: 0px ${theme.spacing.km3};
        background-color: ${theme.color.background.neutral.weak};
        color: ${theme.color.text.neutral.default};
        border-top-left-radius: ${theme.border.radius.medium};
        border-bottom-left-radius: ${theme.border.radius.medium};
        margin-left: 1px;
        font-size: ${theme.font.size.m2};
        font-weight: ${theme.font.weight.bold};
        line-height: 150%;
      }
    }
  `}
`;

export const ErrorMessage = styled.span<{ hasError: boolean }>`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.modal};
  color: ${({ theme }) => theme.color.text.danger.default};
  font-size: ${({ theme }) => theme.font.size.m2};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  top: ${({ theme }) => theme.spacing.km12};
  padding: ${({ theme }) => theme.spacing.km1} 0 0;
  left: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  fuel-button::part(button) {
    background: #002b5c0f;
    border-color: transparent;
    border-radius: ${({ theme }) => theme.border.radius.pill};
    padding: 0 ${({ theme }) => theme.spacing.km4};
    width: 137px;
    height: 40px;
    font-size: ${({ theme }) => theme.font.size.m3};
    line-height: ${({ theme }) => theme.font.lineHeight.medium};
    letter-spacing: ${({ theme }) => theme.font.spacing.cozy};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    :focus {
      box-shadow: none;
    }
  }
`;
